import { useState } from 'react';
import {
  audio,
  courseCodeTypes,
  navRoutes,
  userRoles,
} from './../../constants';
import Modal from '../Modal';
import { Row, Col } from '../Grid';
import { BasicButton, PlayButton } from '../Button';
import { getMediaUrl } from '../../helpers';
import Icon from '../Icon';
import { useGeneralState } from '../../context/general-state';
import { useNavigate } from 'react-router-dom';
import * as S from './style';
import { useExercise } from 'context/exercise';
import { useCreateStuckAt } from 'api-calls/learners.queries';
import { useAuth } from 'context/auth';
import DrawingPad from 'components/DrawingPad';
import { useSiteSettings } from 'context/site-settings';

const ParkingIconAndModal = () => {
  const [parkingModalVisible, setParkingModalVisible] = useState(false);
  const [showDrawingPad, setShowDrawingPad] = useState(false);
  const [drawingData, setDrawingData] = useState(
    '{"lines":[],"width":345,"height":523}'
  );
  const { state: generalState } = useGeneralState();
  const { courseCode } = useSiteSettings();
  const navigate = useNavigate();
  const { user } = useAuth();

  const pushToDashboard = () => {
    if (generalState?.isPlayground) {
      return navigate(navRoutes.COMMON.EXERCISES_PLAYGROUND);
    }
    if (user.role === userRoles.COACH) {
      return navigate(
        navRoutes.COACH.LEARNER_DASHBOARD.replace(':id', learnerId)
      );
    }
    navigate(navRoutes.LEARNER.DASHBOARD);
  };

  const { currentStep } = useExercise();
  const learnerId =
    user.role === userRoles.LEARNER ? user.id : user.selectedLearnerId;
  const { mutateAsync: createStuckAt } = useCreateStuckAt();

  const markActiveStepAsSaved = async () => {
    await createStuckAt({
      stepId: currentStep?.id,
      learnerId,
    });
  };

  const handleSaveStep = async () => {
    if (generalState?.isLearning) {
      await markActiveStepAsSaved();
    }
    setParkingModalVisible(true);
  };

  return (
    <>
      <S.IconButton
        onClick={handleSaveStep}
        arai-label="show-parking-button"
        title="show-parking-button"
        data-test-id="exercise-parking-button"
      >
        <Icon
          icon="questionMark"
          color="neutralMain"
          ml={1}
          style={{ cursor: 'pointer' }}
          width={44}
          height={44}
        />
      </S.IconButton>
      <Modal
        visible={parkingModalVisible}
        data-test-id="exercise-parking-saved-popup"
      >
        <Row>
          <Col w={[4, 12, 12]} jc="center">
            <Icon icon="bookmarkSaved" color="white" width="70" height="70" />
          </Col>

          <Col w={[4, 12, 12]} jc="center" mt={3}>
            <PlayButton
              color="neutralSurface"
              audioUrl={getMediaUrl(
                audio.parkingPageSaved,
                true,
                generalState?.preferredVoice
              )}
              fallbackText="Parking page saved"
            >
              Parking page saved
            </PlayButton>
          </Col>

          <Col w={[4, 12, 12]} mt={4}>
            <BasicButton
              handleClick={() => {
                pushToDashboard();
                setParkingModalVisible(false);
              }}
              icon="tick"
              variant="secondary"
              iconProps={{ width: '13', height: '11.5' }}
              focusOutlineColor="neutralSurface"
              data-test-id="exercise-parking-saved-popup-ok-button"
            />
          </Col>
        </Row>
      </Modal>
      {courseCode === courseCodeTypes.CMID && (
        <>
          <S.IconButton
            onClick={() => setShowDrawingPad((prev) => !prev)}
            arai-label="show-drawing-pad-button"
            title="show-drawing-pad-button"
          >
            <Icon
              icon="pencil"
              color="neutralMain"
              ml={1}
              style={{ cursor: 'pointer' }}
            />
          </S.IconButton>
          {showDrawingPad && (
            <DrawingPad
              drawingData={drawingData}
              setDrawingData={setDrawingData}
              setShowDrawingPad={setShowDrawingPad}
            />
          )}
        </>
      )}
    </>
  );
};

export default ParkingIconAndModal;
